<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newUser()"
                aria-label="New trainer"
                *appIsGranted="['Workers', 'CREATE']"
        >
            {{'New'|translate}}
        </button>
    </div>

    <div class="nav material2">

    </div>

</div>
<!-- / SIDEBAR CONTENT -->
